import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import './Lightbox.css';

export default class Lightbox extends Component {
  state = { mounted: false };

  componentDidMount() {
    // Avoid SSR mismatch; only portal after mount
    this.setState({ mounted: true });
  }

  render() {
    const { className = '', open, onClose, style, children } = this.props;

    // If not open, render nothing (prevents tab focus / screen-reader bleed)
    if (!open) return null;
    if (!this.state.mounted) return null;

    const node = (
      <div className={`${className} lightbox-container`}>
        <div className="lightbox-inner" onClick={onClose}>
          <div className="lightbox" style={style} onClick={e => e.stopPropagation()}>
            {children}
          </div>
        </div>
      </div>
    );

    return createPortal(node, document.body);
  }
}